export type ScrollDirection = 'vertical' | 'horizontal'
export type BuiltInScrollMode = 'smooth' | 'disable' | 'default'
export type ScrollMode = BuiltInScrollMode | string

/**
 * Describes current scroll-related state for all calculations and modules.
 */
export class ScrollState {
  /** Target scroll value — where we want to scroll to (used in smooth scroll) */
  target: number = 0

  /** Current scroll value (actual scroll position) */
  current: number = 0

  /** Transformed current scroll value (with transform by scroll container) */
  transformedCurrent: number = 0

  /** Delta between frames (used for animation / velocity) */
  delta: number = 0

  /** Interpolated scroll value for smooth transitions */
  lerped: number = 0

  /** Displacement value (similar to lerped, but used for other animations) */
  displacement: number = 0

  /** Whether scroll direction is downward */
  isScrollingDown: boolean = false

  /** Top screen scroll position */
  topPosition: number = 0

  /** Bottom screen scroll position */
  bottomPosition: number = 0

  /** Scroll direction (vertical / horizontal) */
  direction: ScrollDirection = 'vertical'

  /** Scroll container element */
  elementContainer: HTMLElement = document.documentElement

  /** Scroll container element */
  scrollContainer: HTMLElement | Window = window

  /** Scroll container element */
  container: HTMLElement = document.body

  /**
   * Currently active scroll mode.
   * Can be 'smooth', 'default', or 'disable'.
   */
  mode: ScrollMode = 'smooth'

  /**
   * Scroll mode to use on mobile devices.
   * Can be 'smooth', 'default', or 'disable'.
   */
  modeMobile: ScrollMode = 'default'

  /**
   * Scroll mode to use on desktop devices.
   * Can be 'smooth', 'default', or 'disable'.
   */
  modeDesktop: ScrollMode = 'smooth'

  /**
   * Base scroll speed used for calculating smooth scrolling.
   * Typically a small value between 0 and 1.
   */
  speed: number = 0.09

  acceleration: number = 0.8

  /**
   * Acceleration factor used for scroll easing or velocity-based animations.
   * Also typically a value between 0 and 1.
   */
  speedAccelerate: number = 0.42

  smoothness: number = 0.5

  multiplier: number = 1.1

  maxDelta: number = 2400

  stopThreshold: number = 0.08

  decelerationCoefficient: number = 1
}
